export const API_ROUTE = {
  ADMIN: 'admin',
  ALERT: 'alert',
  ANALYTICS: 'analytics',
  AUDIT: 'audit',
  CHART: 'chart',
  CHAT: 'chat',
  COMPLIANCE: 'compliance',
  DASHBOARD: 'dashboard',
  DCA: 'dca',
  DISCOVERY: 'discovery',
  FEEDBACK: 'feedback',
  GOVERNANCE: 'governance',
  INSTANCE: 'instance',
  KEYS: 'keys',
  GET_KEYS: 'get-keys',
  LIST: 'list',
  LOGIN: 'login',
  MASTER: 'master',
  NOTIFICATION: 'notification',
  PAGE: 'page',
  PERMISSION: 'permission',
  USER_PERMISSIONS: 'user-permissions',
  PIPELINE: 'pipeline',
  QUESTIONNAIRE: 'questionnaire',
  RESPONSE: 'response',
  RULESET: 'ruleset',
  RUN: 'run',
  SERVICES: 'services',
  SOURCE: 'source',
  START: 'start',
  SUMMARY: 'summary',
  TARGET: 'target',
  USER: 'user',
  UPDATE_USER: 'update-user',
  USERS: 'users',
  GET_USERS: 'get-users',
  VISITS: 'visits',

  REFRESH_TOKEN: 'refresh-token',
  CREATE_DIAGRAM: 'creatediagram',
  RULESET_HISTORY: 'getapirules',
  PIPELINE_CUMULATIVE: 'pipeline-cumulative',
  NOTIFICATION_STATUS: 'notification-status',
  GET_ROLE_BASED_USAGE: 'admin-vs-users',
  GET_CATEGORY_DOMAIN: 'get-category-domain',
  COMPLIANCE_CUMULATIVE: 'compliance-cumulative',
  CREATE_MULTI_CLOUD: 'createMultiCloud',
  IMAGE_UPLOAD: 'image-upload',
  ACTIVE_USERS: 'active-users',
  PAGE_VIEWS: 'page-views',
  AVERAGE_SESSION_TIME: 'average-session-time',
  APP_STREAM: 'app-stream',
  DOWNLOAD_TERRAFORM: 'download-terraform',
  NEW_VS_RETURNING_USERS: 'new-vs-returning-users',
  USER_ACTIVITY: 'user-activity',
  CLIENT_CUSTOMIZATION: 'client-customization',
  MIGRATE_VM: 'migrateVM',
  PIN_ACCOUNT: 'pinaccount',
  PLAN_CAPABILITY_DETAILS: 'plan/capability_details',
  GET_FOUNDATION_HISTORY: 'get_foundation_history',
  DOWNLOAD_WORKFLOW_LOGS: 'download-workflow-logs',
  CREATE_CUSTOM_LANDING_ZONE: 'create-custom-landing-zone',
  LANDING_ZONE: {
    BASE: 'landing-zone',
    ALTERNATE: 'landingzone',
    CREATE: 'create-landing-zone',
    CREATE_CUSTOM: 'create-custom-landing-zone',
    CREATE_ENV: 'createLandingZone',
    DESTROY: 'destroy-landing-zone', //'destroyLandingZone'
    GET_LANDING_ZONE: 'getLandingZone',
    STATUS: 'landingZoneStatus', //Need to be changed from backend
    INDUSTRY: 'industry-landing-zone',
    MULTI_CLOUD: 'multi-cloud-landing-zone',
    GET_LANDING_ZONE_DETAILS: 'get-landing-zone-details',
  },
  CWB: {
    BASE: 'cwb',
    REFRESH_TOKEN: 'cwb-refresh-token',
    GET_CHART_DATA: 'bauvscloud',
    GET_FIVE_YR_PL_DATA: 'exportchartdata',
    GET_COMPUTE_COST_DATA: 'computecost',
    GET_STORAGE_COST_DATA: 'storagecost',
    GET_HEATMAP_DATA: 'heatmap',
    GET_ASSESSMENT_DATA: 'configurecomponents',
    GET_CATEGORIES_DATA: 'assessmentdetailspopup',
    CHARTS: 'charts',
    APP_SCOPE_ADJUSTMENT_DATA: 'scopeplacement', //Might not be getting used in DCA
    APP_INSCOPE_DATA: 'inoutscope', //Might not be getting used in DCA
    APP_ADJUSTMENT_COUNT: 'breakdowncount', //Might not be getting used in DCA
  },
  WORKFLOW: {
    BASE: 'workflow',
    STATUS: 'get-workflow-details',
    DETAILS: 'get-workflow-details',
  },
  S3: {
    PRESIGNED_URL: 'presigned-url',
    FILES: 's3-files',
    BUCKET: 's3bucket',
  },
  MICROSERVICES: {
    CREATE: 'createMicroservices',
    DESTROY: 'destroyMicroservice',
  },
  ARCHITECTURE: {
    BASE: 'architecture',
    UPLOAD: 'architecture-upload',
    DOWNLOAD: 'architecture-download',
  },
  ASSESSMENTS: {
    BASE: 'assessments',
    ALTERNATE: 'assessment',
    PROVIDERS: 'providers',
    QUESTIONS: 'questions',
    DOWNLOAD: 'download',
    SUBMIT: 'submit',
    DELETE: 'delete',
    CARDS: 'assessment-cards',
    DEVOPS_UPLOAD: 'assessment-upload',
  },

  CLOUD_ASSESSMENTS: {
    BASE: 'cloud-assessments',
    GENRATE: 'generate',
    DOWNLOAD: 'download',
  },

  VALIDATE_LANDING_ZONE: 'validate-landing-zone',

  VALIDATE_CUSTOM_CONFIGURATION: 'validate-custom-configuration',
  VALIDATE_CUSTOM_TERRAFORM_PLAN: 'validate-custom-terraform-plan',
  YAML: {
    BASE: 'yaml',
    VALIDATE_YAML: 'validate-yaml',
    VALIDATE_REPORT: 'validation-report',
    VALIDATE_CONFIGURATION: 'validate-configuration',
    VALIDATE_TERRAFORM_PLAN: 'validate-terraform-plan',
    CONTENT: 'yaml-content',
    POLICY: 'policy-yaml',
  },
  CLOUD: {
    BASE: 'cloud',
    CSP: 'cloud-csp',
    STATUS: 'cloud-status',
    ASSESSMENT: 'cloud-assessment',
  },
  GEN_AI: {
    BASE: 'ai-chat-session',
    ARCHITECTURE: {
      BASE: 'genai-architecture',
      REVISE: 'revise',
      GENERATE: 'generate',
      CONVERT: 'convert',
      UPLOAD: 'upload',
    },
    ALTERNATE: 'ai-chat-sessions',
    AUTO_COMPLETE_OPTIONS: 'ai-chat-autocomplete',
    DETAILS: 'details',
    ARCHIVE: 'archive',
    DOCUMENT_UPLOAD: 'document-upload',
    DOCUMENT_SEARCH: 'document-search',
  },
  SITE_RELIABILITY: {
    BASE: 'fis',
    TRIGGER: 'trigger',
    GET_STATUS: 'getstatus',
    PROMETHEUS: 'api/server',
  },
  INDUSTRY_COMPLIANCE: {
    POLICIES: 'industry-policies',
    STANDARD_POLICIES: 'industry-standard-policies',
    COMPLIANCES: 'industry-compliances',
  },
  MODERNIZATION: {
    BASE: 'modernization',
    ENVIRONMENTS: 'env',
    WORKLOAD_PATTERNS: 'workload',
    APPLICATIONS: 'apps',
    DEPLOY_APPLICATION_AKS: 'deploy-app-aks',
    CREATE_WROKLOAD_PATTERN: 'create-workload-pattern',
  },
  WORKFLOW_CONSOLE_START:
    'https://vsrm.dev.azure.com/CE-DevOpsCloud/DCP/_apis/release/releases?api-version=6.0',
  LANDING_ZONE_STATUS: 'https://tangradcaapi.deloitte.com/listen/',
  GEN_AI_CREATE: {
    SERVICES: 'cloud-services',
    GENERATE_TERRAFORM: 'generate-ai-terraform-module',
    POLL_GENERATION_COMPLETED: 'poll-ai-terraform-module',
    DOWNLOAD_TERRAFORM: 'download-terraform-modules', //'download-ai-terraform-module',
    UPLOAD_TERRAFORM: 'upload-terraform-modules'
  },
  TFVARS: {
    RETURN_TFVARS: 'return-tfvars',
  },
  ACCOUNT: {
    BASE: 'account',
    CREATE: 'create-account',
  },
  PROJECT: {
    BASE: 'project',
    GET_PROJECTS: 'get-projects',
    CREATE: 'create-project',
    UPDATE: 'update-project',
  },
  GET_CONFIG_VARIABLES: 'variables',
};
